import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { isExactProductVariantIdentityResponse } from '@theme/discovery-authority-state';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  #selectionGeneration = 0;

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#selectionGeneration += 1;
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const generation = ++this.#selectionGeneration;
    const { variantId = '', connectedProductId = '' } = event.detail ?? {};
    const expectedProductId = String(connectedProductId || event.target.getAttribute('data-product-id') || '');
    const intendedVariantId = String(variantId || '');
    this.hidden = true;

    event.promise
      .then(({ detail }) => {
        if (generation !== this.#selectionGeneration || !this.isConnected || !detail?.html) return;

        const { html, resource } = detail;
        const responseCarrier = html.querySelector('[data-product-grid-content]');
        const responseProductId = responseCarrier?.getAttribute('data-product-id')?.trim() ?? '';
        const approvedVariantId = responseCarrier?.getAttribute('data-approved-variant-id')?.trim() ?? '';
        const newInventory = responseCarrier?.querySelector('product-inventory');
        const serverAllowed = isExactProductVariantIdentityResponse({
          launchAllowed:
            responseCarrier?.getAttribute('data-launch-allowed') === 'true' &&
            newInventory?.getAttribute('data-launch-allowed') === 'true' &&
            newInventory?.getAttribute('data-approved-variant-id') === approvedVariantId,
          expectedProductId,
          responseProductId,
          intendedVariantId,
          approvedVariantId,
          resourceId: String(resource?.id ?? ''),
          available: resource?.available === true,
        });

        if (!serverAllowed || !(newInventory instanceof HTMLElement)) return;
        if (generation !== this.#selectionGeneration || !this.isConnected) return;

        morph(this, newInventory, { childrenOnly: true });
        this.dataset.productId = responseProductId;
        this.dataset.approvedVariantId = approvedVariantId;
        this.dataset.launchAllowed = 'true';
        this.hidden = false;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
